import React from 'react'
import { CustomTable } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import { planeCalculateResponseColumns } from 'src/core/table-columns'
import { getCsvFromObjectArray, downloadCsv, getActualDateFormated } from 'src/core/helpers'
import ResponseListHeader from '../ResponseListHeader/ResponseListHeader'


const PlanesCalculateResponseList = ({ loading }) => {
  const { data } = useAppSelector((state) => state.admin.massiveCalculation.responseCalculate)

  const getvalue = (record: any) => {
    const value = record?.response?.isError ?
      0 : record?.response?.result?.value
    return value
  }

  const handleCsvDownload = () => {
    const results = data.map((dataItem) => {
      return {
        idTrip: dataItem.item.idTrip,
        'class': dataItem.item.class,
        from: dataItem.item.from,
        to: dataItem.item.to,
        paxes: dataItem.item.paxes,
        roundTrip: dataItem.item.roundTrip,
        kg_co2: getvalue(dataItem)
      }
    })
    const csv = getCsvFromObjectArray(results)
    const csvFileName = `${getActualDateFormated()}_planes`
    downloadCsv(csv, csvFileName)
  }

  return (
    <>
      {/* Header Content */}
      <ResponseListHeader
        loading={loading}
        length={data?.length}
        handleCsvDownload={handleCsvDownload}
      />
      {/* Table Results */}
      <CustomTable
        columns={planeCalculateResponseColumns}
        dataSource={data}
      />
    </>
  )
}


export default PlanesCalculateResponseList
